import React from "react";
import { NavLink } from "react-router-dom";

const NavBar = () => {
  return (
    <nav className="site-main-menu">
      <ul>
        <li>
          <NavLink to={process.env.PUBLIC_URL + "/hjem"}>
            <span className="menu-text">hjem</span>
          </NavLink>
        </li>
        <li>
          <NavLink to={process.env.PUBLIC_URL + "/om"}>
            <span className="menu-text">om oss</span>
          </NavLink>
        </li>
        <li>
          <NavLink to={process.env.PUBLIC_URL + "/referanser"}>
            <span className="menu-text">referanser</span>
          </NavLink>
        </li>
      </ul>
    </nav>
  );
};

export default NavBar;
